<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import CampaignCartOverview from "@/components/cartWidgets/campaignCartOverview";
import {cloneDeep} from 'lodash';
import {convertToSQLDate, Toast} from "@/state/helpers";
import axios from "axios";
import Swal from "sweetalert2";
import {getVatRate} from "@/helpers/vat_rates";

/**
 * Product-cart component
 */
export default {
  components: {CampaignCartOverview, Layout, PageHeader},
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    campaignCartItems() {
      let campaignCartItems = this.$store.state.cart.cart;
      const campaignId = this.$route.params.campaignId;
      // if companyId is passed in url we will show cart items only for that specific campaign
      if (campaignId && campaignId in campaignCartItems) {
        const campaignCertItem = campaignCartItems[campaignId];
        campaignCartItems = {
          campaignId: campaignCertItem
        };
      }

      return campaignCartItems;
    },
    hasCampaignItems() {
      return Object.keys(this.campaignCartItems).length > 0
    },
    hasOnDemandPrices() {
      // eslint-disable-next-line no-unused-vars
      for (let [campaignId, campaignCartItem] of Object.entries(this.campaignCartItems)) {
        // eslint-disable-next-line no-unused-vars
        for (let [influencerId, influencerCartItem] of Object.entries(campaignCartItem.influencerCartItems)) {
          // eslint-disable-next-line no-unused-vars
          for (let [pricePackageId, pricePackageCartItem] of Object.entries(influencerCartItem.pricePackageCartItems)) {
            if (!pricePackageCartItem.pricePackage.total_gross_price) {
              return true;
            }
          }
        }
      }

      return false;
    },
    totalInfluencers() {
      let totalInfluencers = 0;

      // eslint-disable-next-line no-unused-vars
      for (let [campaignId, campaignCartItem] of Object.entries(this.campaignCartItems)) {
        // eslint-disable-next-line no-unused-vars
        for (let [influencerId, influencerCartItem] of Object.entries(campaignCartItem.influencerCartItems)) {
          // eslint-disable-next-line no-unused-vars
          totalInfluencers += 1;
        }
      }

      return totalInfluencers;
    },
    totalPosts() {
      let totalPosts = 0;

      // eslint-disable-next-line no-unused-vars
      for (let [campaignId, campaignCartItem] of Object.entries(this.campaignCartItems)) {
        // eslint-disable-next-line no-unused-vars
        for (let [influencerId, influencerCartItem] of Object.entries(campaignCartItem.influencerCartItems)) {
          // eslint-disable-next-line no-unused-vars
          for (let [pricePackageId, pricePackageCartItem] of Object.entries(influencerCartItem.pricePackageCartItems)) {

            let pricePackagePostsCount = 0
            for (let pricePackageItem of pricePackageCartItem.pricePackage.price_package_items) {
              pricePackagePostsCount += pricePackageItem.quantity;
            }

            totalPosts += (pricePackagePostsCount * pricePackageCartItem.amount)
          }
        }
      }

      return totalPosts;
    },
    totalGrossPrice() {
      let totalGrossPrice = 0;

      // eslint-disable-next-line no-unused-vars
      for (let [campaignId, campaignCartItem] of Object.entries(this.campaignCartItems)) {
        // eslint-disable-next-line no-unused-vars
        for (let [influencerId, influencerCartItem] of Object.entries(campaignCartItem.influencerCartItems)) {
          // eslint-disable-next-line no-unused-vars
          for (let [pricePackageId, pricePackageCartItem] of Object.entries(influencerCartItem.pricePackageCartItems)) {
            if (pricePackageCartItem.pricePackage.total_gross_price) {
              console.log(pricePackageCartItem.pricePackage);
              totalGrossPrice += pricePackageCartItem.pricePackage.total_gross_price * pricePackageCartItem.amount;
            }
          }
        }
      }

      return totalGrossPrice;
    },
    totalNetPrice() {
      let totalNetPrice = 0;

      // eslint-disable-next-line no-unused-vars
      for (let [campaignId, campaignCartItem] of Object.entries(this.campaignCartItems)) {
        // eslint-disable-next-line no-unused-vars
        for (let [influencerId, influencerCartItem] of Object.entries(campaignCartItem.influencerCartItems)) {
          // eslint-disable-next-line no-unused-vars
          for (let [pricePackageId, pricePackageCartItem] of Object.entries(influencerCartItem.pricePackageCartItems)) {
            if (pricePackageCartItem.pricePackage.total_net_price) {
              totalNetPrice += pricePackageCartItem.pricePackage.total_net_price * pricePackageCartItem.amount;
            }
          }
        }
      }

      return totalNetPrice;
    },
    platformFee() {
      const platformFee = this.user.client.platform_fee ? this.user.client.platform_fee : 0;

      return this.totalNetPrice * platformFee;
    },
    totalGrossPriceWithFee() {
      return this.totalGrossPrice + this.platformFee;
    },
    vat() {
      const vatRate = getVatRate(this.user.country);

      return this.totalGrossPriceWithFee * vatRate;
    },
    grandTotalPrice() {
      return this.totalGrossPrice + this.platformFee + this.vat;
    }
  },
  data() {
    return {}
  },
  methods: {
    async confirmOffers() {
      Swal.fire({
        title: "Confirm your offers",
        text: 'You will find them on Offers board',
        icon: "info",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#019dcb",
        cancelButtonColor: "#868585",
        confirmButtonText: "Send offers",
      }).then(result => {
        if (result.value) {
          this.sendOffers()
        }
      });
    },
    async sendOffers() {
      const offers = [];

      // eslint-disable-next-line no-unused-vars
      for (let [campaignId, campaignCartItem] of Object.entries(this.campaignCartItems)) {
        // eslint-disable-next-line no-unused-vars
        for (let [influencerId, influencerCartItem] of Object.entries(campaignCartItem.influencerCartItems)) {
          const expiresDate = new Date();
          expiresDate.setDate(expiresDate.getDate() + 3);

          const campaignAgreement = {
            campaign_id: campaignCartItem.campaignId,
            influencer_id: parseInt(influencerId),
            offer_message: null,
            offer_expires_at: convertToSQLDate(expiresDate),
            price_packages: []
          }

          // this is influencer with prices, not on demand
          if (Object.values(influencerCartItem.pricePackageCartItems)[0].pricePackage.total_gross_price) {
            // eslint-disable-next-line no-unused-vars
            for (let [pricePackageId, pricePackageCartItem] of Object.entries(influencerCartItem.pricePackageCartItems)) {
              const pricePackages = Array(pricePackageCartItem.amount).fill(null).map(() => {
                const pricePackage = cloneDeep(pricePackageCartItem.pricePackage)
                delete pricePackage['pricePackageItemsBySocialNetwork']; // Probably, this field does not exist anymore
                return pricePackage;
              })

              campaignAgreement.price_packages.push(...pricePackages)
            }
          } else {
            // TODO public campaign name
            const pricePackage = {
              name: `${campaignCartItem.campaignInternalName} - offer`,
              price_package_items: []
            }
            // eslint-disable-next-line no-unused-vars
            for (let [pricePackageId, pricePackageCartItem] of Object.entries(influencerCartItem.pricePackageCartItems)) {
              for (let pricePackageItem of pricePackageCartItem.pricePackage.price_package_items) {
                // Copied instance to prevent changes on the state
                const pricePackageItemCopy = cloneDeep(pricePackageItem)
                pricePackageItemCopy.quantity = pricePackageCartItem.amount;
                pricePackage.price_package_items.push(pricePackageItemCopy)
              }
            }
            campaignAgreement.price_packages.push(pricePackage)
          }

          offers.push(campaignAgreement)
        }
      }

      this.$store.commit('loader/START_LOADING');
      try {
        await axios.post(`/client/campaign-agreement`, {
          campaign_agreements: offers
        });

        if (this.$route.params.campaignId) {
          this.$store.commit('cart/REMOVE_CAMPAIGN_CART_ITEM', this.$route.params.campaignId);
        } else {
          this.$store.commit('cart/CLEAR_CART');
        }

        await this.$router.push({name: 'client_offers_board'})

        Toast.fire({
          title: "Offers sent",
          icon: "success",
        })
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="'Cart'"/>
    <div class="row" v-if="hasCampaignItems">
      <div class="col-12 col-xl-8">
        <div class="">
          <div class="">
            <div v-for="campaignCartItem in campaignCartItems" :key="campaignCartItem.campaignId" class="mb-3">
              <campaign-cart-overview :campaignCartItem="campaignCartItem"></campaign-cart-overview>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Order Summary</h4>

            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>

<!--                <tr>-->
<!--                  <th>-->
<!--                    Total Influencers :-->
<!--                  </th>-->
<!--                  <th>{{ totalInfluencers.toLocaleString() }}</th>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <th>-->
<!--                    Total Posts :-->
<!--                  </th>-->
<!--                  <th>{{ totalPosts.toLocaleString() }}</th>-->
<!--                </tr>-->
                <tr>
                  <th>
                    Subtotal :
                  </th>
                  <th class="text-right">&euro;{{ totalGrossPrice.toLocaleString() }}</th>
                </tr>
                <tr>
                  <th>
                    Platform Fee :
                  </th>
                  <th class="text-right">&euro;{{ platformFee.toLocaleString() }}</th>
                </tr>
                <tr>
                  <th>
                    VAT :
                  </th>
                  <th class="text-right">&euro;{{ vat.toLocaleString() }}</th>
                </tr>
                <tr class="font-size-15">
                  <th>
                    Grand Total :
                  </th>
                  <th class="font-size-15 text-right">&euro;{{ grandTotalPrice.toLocaleString() }}</th>
                </tr>
                </tbody>
              </table>
              <span class="text-muted" v-if="hasOnDemandPrices">
                <td>*This price is subject to change because you have included influencers with on-demand pricing.</td>
              </span>
            </div>
            <!-- end table-responsive -->

            <div class="row mt-4">
              <div class="col-sm-6">
                <a @click="$router.go(-1)" class="btn btn-secondary">
                  <i class="mdi mdi-arrow-left mr-1"></i> Go Back
                </a>
              </div>
              <!-- end col -->
              <div class="col-sm-6">
                <div class="text-sm-right mt-2 mt-sm-0">
                  <a @click="confirmOffers" class="btn btn-primary">
                    <i class="fas fa-paper-plane mr-1"></i> Send offers
                  </a>
                </div>
              </div>
              <!-- end col -->
            </div>
          </div>
        </div>
        <!-- end card -->

      </div>
    </div>
    <div v-else class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body d-flex ">
            <img src="@/assets/images/empty-cart.png" style="width: 100px" class="mr-4">
            <div>
              <h3>Your Influencertes Cart is empty</h3>
              <router-link to="/client/influencers" tag="a" class="font-size-16">
                Find influencers for your campaign
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
